import { STRAIN_ORDER } from '@/constants';

const strainOrderIndex = new Map(
  STRAIN_ORDER.map((label, index) => [label.toLowerCase(), index]),
);

export const sortByClassificationFilter = (values: string[]) =>
  [...values].sort((a, b) => {
    const indexA = strainOrderIndex.get(a.toLowerCase());
    const indexB = strainOrderIndex.get(b.toLowerCase());

    return (indexA ?? Infinity) - (indexB ?? Infinity);
  });

export const ordenFilterItems = (
  items: string[],
  attribute: string,
): string[] => {
  const applyClassificationSort = attribute === 'classification';

  if (applyClassificationSort) {
    return sortByClassificationFilter(items);
  }

  return [...items].sort();
};
